import React from 'react';
import ContactUs from '../components/3_Organisms/ContactUs/ContactUs';
import EVBatteryCalculator from '../components/3_Organisms/EVBatteryCalculator/EVBatteryCalculator';
import EVRangeMap from '../components/3_Organisms/EVRangeMap/EVRangeMap';
import FindADealer from '../components/3_Organisms/FindADealer/FindADealer';
import KMI from '../components/3_Organisms/KMI/KMI';
import KMIModal from '../components/3_Organisms/KMI/KMIModal';
import SaveBuildModal from '../components/3_Organisms/SaveBuildModal/SaveBuildModal';
import SendBuildToDealerModal from '../components/3_Organisms/SendBuildToDealerModal/SendBuildToDealerModal';
import ShareBuildModal from '../components/3_Organisms/ShareBuildModal/ShareBuildModal';
import BookServiceAppointment from '../components/5_Pages/BookServiceAppointment/BookServiceAppointment';
import BookTestDrive from '../components/5_Pages/BookTestDrive/BookTestDrive';
import GetQuote from '../components/5_Pages/GetQuote/GetQuote';
import TradeInEstimator from '../components/5_Pages/TradeInEstimator/TradeInEstimator';

export const KMI_Block = (props) => <KMI {...props} />;
export const KMIModal_Block = (props) => <KMIModal {...props} />;
export const ContactUs_Block = (props) => <ContactUs {...props} />;
export const FindADealer_Block = (props) => <FindADealer {...props} />;
export const BookTestDrive_Block = (props) => <BookTestDrive {...props} />;
export const GetQuote_Block = (props) => <GetQuote {...props} />;
export const TradeInEstimator_Block = (props) => <TradeInEstimator {...props} />;
export const BookServiceAppointment_Block = (props) => <BookServiceAppointment {...props} />;
export const EVRangeMap_Block = (props) => <EVRangeMap {...props} />;
export const SaveBuildModal_Block = (props) => <SaveBuildModal {...props} />;
export const ShareBuildModal_Block = (props) => <ShareBuildModal {...props} />;
export const SendBuildToDealerModal_Block = (props) => <SendBuildToDealerModal {...props} />;
export const EVBatteryCalculator_Block = (props) => <EVBatteryCalculator {...props} />;
